export enum Role {
  ADMIN = "admin",
  MANAGER = "manager",
  COACH = "coach",
  USER = "user",
}

export const DASHBOARD_ROLES = [Role.ADMIN, Role.MANAGER, Role.COACH];

export const ASSIGNABLE_ROLES = [Role.USER, Role.MANAGER, Role.COACH, Role.ADMIN];

export interface JwtPayload {
  sub?: string;
  id?: string;
  username?: string;
  roles?: string[];
  exp?: number;
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export interface RefreshTokenRequest {
  refresh_token: string;
}

export interface RegisterRequest {
  username: string;
  email: string;
  phone?: string;
  password: string;
  password_confirm: string;
  Fname?: string | null;
  Lname?: string | null;
  data?: Record<string, unknown>;
}

export interface AdminCreateUserRequest {
  username: string;
  email: string;
  phone?: string;
  password: string;
  password_confirm: string;
  roles?: Role[];
}

export interface UserSchema {
  id: string;
  username: string;
  email: string;
  phone: string;
  roles?: string[];
  created_at: string;
  updated_at: string;
  data?: Record<string, unknown>;
}

export interface UpdateUserRequest {
  username?: string | null;
  email?: string | null;
  phone?: string | null;
  roles?: string[] | null;
  Fname?: string | null;
  Lname?: string | null;
  data?: Record<string, unknown> | null;
}

export const getPrimaryRole = (roles?: string[]): Role => {
  if (!roles?.length) return Role.USER;
  if (roles.includes(Role.ADMIN)) return Role.ADMIN;
  if (roles.includes(Role.MANAGER)) return Role.MANAGER;
  if (roles.includes(Role.COACH)) return Role.COACH;
  return Role.USER;
};

export const formatRolesLabel = (roles?: string[]) =>
  roles?.length ? roles.join(", ") : "user";
